import { debug } from 'lib/logging'

export const SMC_ORG_ID = `5044d341-1053-4ffe-b6ad-5924a0dc5b60`

export function isSMCOrg(orgId: string | undefined) {
  debug(`smc`, `isSMCOrg`, orgId, process.env.IS_SMC_ORG)
  if (typeof process && process.env.IS_SMC_ORG) return process.env.IS_SMC_ORG === `true`
  if (typeof process !== `undefined` && process.env.TESTING) return true
  return orgId === SMC_ORG_ID
}
